export default __webpack_public_path__ + "static/media/199.fbc88b61.gif";